angular.module( 'acme.view.application.importExport.job', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.importExport.importExportJob.directives.importExportJobExecutionGrid',
  'acme.view.application.importExport.job.controllers',
  'acme.view.application.importExport.exportJobExecution.directives.exportJobExecutionOutputs'
])

.config(function config( $stateProvider ) {
  var importExportJob = {
    name: 'application.importExport.job',
    url: '/job/:id',
    views: {
      "subview-main": {
        controller: 'ImportExportJobController',
        controllerAs: '$ctrl',
        templateUrl: 'views/application/views/importExport/importExportJob/importExportJob.tpl.html'
      }
    },
    data: {
      pageTitle: 'Import Export - Job',
      enablePreferences: true
    }
  };

  $stateProvider
    .state(importExportJob);
});
